import { render, staticRenderFns } from "./v2userapplayout.vue?vue&type=template&id=ecde9860&"
import script from "./v2userapplayout.vue?vue&type=script&lang=js&"
export * from "./v2userapplayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports